<template>
  <div class="box">
    <div class="box-in" v-for="(item,index) in listData" :key="index">
      <span v-if="item.evaluationAdvice">{{item.evaluationAdvice}}</span> <br><br>
      <span v-if="item.evaluationScore">分数：{{item.evaluationScore}}</span>
      <span v-else>{{$t('common.noData')}}</span>
      <div style="margin-top: 10px;">
        <span>{{$t('common.reviewerMan')}}：</span>
        <span v-if="item.userName">{{item.userName}}</span>
      </div>
    </div>
    <div v-if="listData.length == 0">
      {{$t('common.noData')}}
    </div>
    <!--      <div class="box-in">-->
    <!--        <span>理论+实证的结合，文章内容充实，对不同类型的码商及影响机制的研究非常完整，是一篇很扎实的论文。</span>-->
    <!--        <div style="margin-top: 10px;"><span>评审人：</span><span>张三</span></div>-->
    <!--      </div>-->
    <!--      <div class="box-in">-->
    <!--        <span>理论+实证的结合，文章内容充实，对不同类型的码商及影响机制的研究非常完整，是一篇很扎实的论文。</span>-->
    <!--        <div style="margin-top: 10px;"><span>评审人：</span><span>张三</span></div>-->
    <!--      </div>-->
  </div>
</template>

<script>
export default {
  props:['docCode'],
  mounted(){
    this.getList();
  },
  data(){
    return {
      listData:[]
    }
  },
  methods:{
    getList(){
      // 获取意见接口
      let data = {
        docCode:this.docCode
      }

      this.$api.requestEvaluationList(data).then((res)=>{
        this.listData = res.data;
      })
      // 获取意见接口 end
    }
  }
}
</script>

<style scoped lang="scss">
.box {
  max-height: 460px;
  overflow: auto;

  .box-in {
    border-bottom: 0.5px solid #a8a8b3;
    margin-bottom: 20px;
  }
}
</style>
